var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "warp"
    }
  }, [_c('div', {
    attrs: {
      "id": "action"
    }
  }, [_c('div', [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('common.payout')))])]), _c('a', {
    attrs: {
      "title": _vm.$t('common.back')
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'cardSelect'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.back')) + " ")])]), _c('div', [_c('form', [_c('fieldset', {
    staticClass: "hide_triangle"
  }, [_c('div', {
    staticClass: "showConfirmMessage"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('check.email')))]), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.displayMessage)
    }
  }), _c('img', {
    attrs: {
      "src": require("@/assets/img/mail.svg"),
      "alt": _vm.$t('common.mail')
    }
  })])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }